import institutionAPI from 'services/institutionAPI'

export default async function getInstitutionPersonalization() {
  const response = await institutionAPI({
    url: '/auth/personalization',
    method: 'GET',
  })

  return response
}
